import { Fragment } from 'react'

import useAgencySelector from '@hooks/useAgencySelector'

import {
  Box, NavigationLinkGroup, NestedNavigation, SelectBox,
} from '@domain-group/suit-theme'

import type { AgencyModel } from '@models/types'

import generateNavigationItems from './utils/generateNavigationItems'

const OverviewsNavigation = () => {
  const agencySelectorPayload = useAgencySelector()
  const {
    callbacks: { selectAgencyId },
    hasMultipleAgencies,
    selectedAgencyId = 'all',
    sortedAgencies,
  } = agencySelectorPayload

  const navigationItems = generateNavigationItems(selectedAgencyId)

  return (
    <NestedNavigation>
      <Box flexDirection="column" flexShrink={0}>
        {hasMultipleAgencies && (
          <Box alignItems="center" borderBottom="1px solid" borderColor="lineColor" padding="large">
            <SelectBox
              // @ts-expect-error TS7006
              callbacks={{ selectItem: item => selectAgencyId(item.key) }}
              items={[
                { key: 'all', title: 'All Agencies' },
                ...sortedAgencies.map((agency: AgencyModel) => ({
                  key: agency.id,
                  title: agency.short_name || agency.title,
                })),
              ]}
              selectedItemKey={selectedAgencyId}
            />
          </Box>
        )}

        <Box flexDirection="column" padding="large">
          {navigationItems.sections?.map(section => (
            <Fragment key={section.key}>
              {section.title && <NestedNavigation.SectionHeader title={section.title} />}

              {section.items?.map(item => (
                <NavigationLinkGroup key={item.key} link={item} secondaryNav sidebarMaximized />
              ))}
            </Fragment>
          ))}
        </Box>
      </Box>
    </NestedNavigation>
  )
}

export default OverviewsNavigation
